module.exports = __webpack_public_path__ + "img/haochen.1eb1e0e2.png";